"use strict";

var _interopRequireWildcard = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteUserAccount = deleteUserAccount;
exports.deleteUserProfile = deleteUserProfile;
exports.getBaselineStatus = getBaselineStatus;
exports.getInfo = getInfo;
exports.getNoOfUsers = getNoOfUsers;
exports.getUser = getUser;
exports.getUserList = getUserList;
exports.globalLogout = globalLogout;
exports.login = login;
exports.refreshCognitoToken = refreshCognitoToken;
exports.updateMyProfile = updateMyProfile;
exports.updateUser = updateUser;
exports.updateUserProfile = updateUserProfile;
var _request = _interopRequireDefault(require("@/utils/request"));
var Constants = _interopRequireWildcard(require("@lifehikes/lh-js-common-lib"));
function login(username, password) {
  const data = {
    username,
    password
  };
  return (0, _request.default)({
    url: '/auth?source=web',
    baseURL: process.env.VUE_APP_BASE_AUTH_API,
    method: 'post',
    data
  });
}
function globalLogout() {
  return (0, _request.default)({
    url: '/vue-element-admin/user/logout',
    method: 'post'
  });
}
function getInfo(token) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/users/me?source=web',
    baseURL: process.env.VUE_APP_BASE_AUTH_API,
    method: 'get',
    headers
  });
}
function getUserList(token, query) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/users?source=' + Constants.SOURCE_ADMIN_PORTAL,
    baseURL: process.env.VUE_APP_BASE_AUTH_API,
    method: 'get',
    headers,
    params: query
  });
}
function getUser(token, uuid) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/users/${uuid}?source=web`,
    baseURL: process.env.VUE_APP_BASE_AUTH_API,
    method: 'get',
    headers
  });
}
function updateUser(token, uuid, data) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/users/${uuid}?source=web`,
    baseURL: process.env.VUE_APP_BASE_AUTH_API,
    method: 'patch',
    headers,
    data
  });
}
function updateMyProfile(token, userObj) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/users/me?source=web',
    baseURL: process.env.VUE_APP_BASE_AUTH_API,
    method: 'patch',
    headers,
    data: userObj
  });
}
function updateUserProfile(token, userObj) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/users/' + userObj.uuid + '?source=web',
    baseURL: process.env.VUE_APP_BASE_AUTH_API,
    method: 'patch',
    headers,
    data: userObj
  });
}
function deleteUserProfile(token, uuid) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/users/${uuid}/delete-permanent`,
    baseURL: process.env.VUE_APP_BASE_AUTH_API,
    method: 'post',
    headers
  });
}
function getNoOfUsers(token, query) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/users/no-of-users',
    baseURL: process.env.VUE_APP_BASE_AUTH_API,
    method: 'get',
    headers,
    params: query
  });
}
function refreshCognitoToken(token) {
  const data = {
    'refreshToken': token
  };
  return (0, _request.default)({
    url: '/auth',
    baseURL: process.env.VUE_APP_BASE_AUTH_API,
    method: 'patch',
    data
  });
}
function getBaselineStatus(token, list) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/users/baselineStatus`,
    baseURL: process.env.VUE_APP_BASE_AUTH_API,
    method: 'post',
    headers,
    data: list
  });
}
function deleteUserAccount(token, uuid) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/users/${uuid}/delete-user-permanent`,
    baseURL: process.env.VUE_APP_BASE_AUTH_API,
    method: 'delete',
    headers
  });
}